import { render } from "./SimpleHeader.vue?vue&type=template&id=96921472&scoped=true"
import script from "./SimpleHeader.vue?vue&type=script&lang=js"
export * from "./SimpleHeader.vue?vue&type=script&lang=js"

import "./SimpleHeader.vue?vue&type=style&index=0&id=96921472&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-96921472"

export default script